import React, { useCallback } from 'react';
import './DualRangeSlider.css';

/**
 * Two-thumb range slider (min/max). Uses overlapping native range inputs.
 */
const DualRangeSlider = ({ min = 0, max = 1000, step = 100, valueMin = 0, valueMax, onChange }) => {
  const cap = valueMax == null ? max : valueMax;
  const safeMin = Math.min(Math.max(min, valueMin), cap);
  const safeMax = Math.max(safeMin, Math.min(max, cap));
  const range = Math.max(max - min, 1);
  const fillLeft = ((safeMin - min) / range) * 100;
  const fillRight = 100 - ((safeMax - min) / range) * 100;

  const emit = useCallback(
    (nextMin, nextMax) => {
      if (onChange) onChange(nextMin, nextMax);
    },
    [onChange]
  );

  return (
    <div className="dual-range-slider">
      <div className="dual-range-slider__track" aria-hidden="true">
        <div
          className="dual-range-slider__fill"
          style={{ left: `${fillLeft}%`, right: `${fillRight}%` }}
        />
      </div>
      <input
        type="range"
        className="dual-range-slider__thumb dual-range-slider__thumb--min"
        min={min}
        max={max}
        step={step}
        value={safeMin}
        onChange={(e) => {
          const v = Number(e.target.value);
          emit(Math.min(v, safeMax), safeMax);
        }}
        aria-label="Minimum price"
      />
      <input
        type="range"
        className="dual-range-slider__thumb dual-range-slider__thumb--max"
        min={min}
        max={max}
        step={step}
        value={safeMax}
        onChange={(e) => {
          const v = Number(e.target.value);
          emit(safeMin, Math.max(v, safeMin));
        }}
        aria-label="Maximum price"
      />
    </div>
  );
};

export default DualRangeSlider;
